import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchCmsMetaData } from "../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../Components/Utility/setMetaTags";
import LoginModal from "./Users/LoginModal";

function Confirm() {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const slotId = queryParams.get("slot");
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const [meta,setMeta] = useState();

  // ✅ State for experience data
  const [experienceData, setExperienceData] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ State for guests
  // const [guests, setGuests] = useState(1);
  const [guests, setGuests] = useState(location.state?.guests || 1);
  const slotDate = location.state?.slotDate;
  const slotDetails = location.state?.slotDetails;
  const [tempGuests, setTempGuests] = useState(guests); // for editing

  // ✅ State for showing modal-like guest editor
  const [showGuestEditor, setShowGuestEditor] = useState(false);

  const [currencyId, setCurrencyId] = useState(
    location.state?.currencyId || "$",
  );
  const [currency, setCurrency] = useState(location.state?.currency || "AUD");
  const [currencysymbol, setcurrencysymbol] = useState(
    location.state?.currency_symbol || "AUD",
  );
  const [totalPrice, setTotalPrice] = useState(location.state?.totalPrice || 1);
  const [packageId, setPackageId] = useState(location.state?.packageId || 1);

  // ✅ State for login modal
  const [loginOpen, setLoginOpen] = useState(false);

  // ✅ Flatten slots into a single array

  useEffect(() => {
    const fetchExperienceDetails = async (currencyId) => {
      try {
        const res = await axios.get(
          `${
            process.env.REACT_APP_API_BASE
          }/getHomeExperienceDetails/${id}?&currency_id=${
            currencyId || "6"
          }&package_id=${packageId}`,
        );

        setExperienceData(res.data);
      } catch (err) {
        console.error("Error fetching experience details:", err);
      } finally {
        setLoading(false);
      }
    };

    // 🔹 Get initial currency from localStorage or set default
    const getCurrencyId = () => {
      const selectedCurrency = JSON.parse(
        localStorage.getItem("selectedCurrency"),
      );
      return selectedCurrency?.id || ""; // using `.id` since your object structure is { id, symbol, ... }
    };

    let currentCurrencyId = getCurrencyId();
    fetchExperienceDetails(currentCurrencyId);

    // 🔹 Listen to changes in localStorage (when updated from any tab)
    const handleStorageChange = (e) => {
      if (e.key === "selectedCurrency") {
        const updatedCurrency = JSON.parse(e.newValue);
        const newCurrencyId = updatedCurrency?.id || "";
        if (newCurrencyId !== currentCurrencyId) {
          currentCurrencyId = newCurrencyId;
          fetchExperienceDetails(newCurrencyId);
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // 🔹 Detect same-tab changes (when you setItem manually)
    const localCheck = setInterval(() => {
      const local = getCurrencyId();
      if (local !== currentCurrencyId) {
        currentCurrencyId = local;
        fetchExperienceDetails(local);
      }
    }, 1200); // check every 1.2s

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(localCheck);
    };
  }, [id]);

  const allSlots = Object.values(experienceData?.data?.slots || {}).flat();
  // ✅ Find the slot by ID
  const currentSlot = allSlots.find((s) => String(s.id) === slotId);


  const [participantCount, setParticipantCount] = useState({
    adults: location.state?.guests?.adults ?? 1,
    children: location.state?.guests?.children ?? 0,
    infants: location.state?.guests?.infants ?? 0,
  });

  // const handleCountChange = (type, action) => {
  //   setParticipantCount((prev) => {
  //     let updated = { ...prev };

  //     const maxAdult = Number(experienceData?.package?.no_of_adult || 0);
  //     const maxChild = Number(experienceData?.package?.no_of_childs || 0);
  //     const maxInfant = Number(experienceData?.package?.no_of_infant || 0);

  //     // Decide total limit priority
  //     let totalLimit = 0;
  //     if (maxAdult > 0) totalLimit = maxAdult;
  //     else if (maxChild > 0) totalLimit = maxChild;
  //     else totalLimit = maxInfant;

  //     const totalAll = prev.adults + prev.children + prev.infants;

  //     // Adults
  //     if (type === "adults") {
  //       if (action === "increment" && totalAll < totalLimit) updated.adults += 1;
  //       else if (action === "decrement" && prev.adults > 1) updated.adults -= 1;
  //     }

  //     // Children
  //     if (type === "children") {
  //       if (action === "increment" && totalAll < totalLimit)
  //         updated.children += 1;
  //       else if (action === "decrement" && prev.children > 0)
  //         updated.children -= 1;
  //     }

  //     // Infants
  //     if (type === "infants") {
  //       if (action === "increment" && totalAll < totalLimit)
  //         updated.infants += 1;
  //       else if (action === "decrement" && prev.infants > 0)
  //         updated.infants -= 1;
  //     }

  //     return updated;
  //   });
  // };

  const handleCountChange = (type, action) => {
    setParticipantCount((prev) => {
      let updated = { ...prev };

      const maxAdult = Number(experienceData?.package?.no_of_adult || 0);
      const maxChild = Number(experienceData?.package?.no_of_childs || 0);
      const maxInfant = Number(experienceData?.package?.no_of_infant || 0);

      // 🟢 Slot availability limit
      const availableLimit = Number(currentSlot?.available_pax || 0);

      const totalSelected = prev.adults + prev.children + prev.infants;

      // Adults
      if (type === "adults") {
        if (action === "increment") {
          if (totalSelected < availableLimit && prev.adults < maxAdult) {
            updated.adults += 1;
          }
        } else if (action === "decrement" && prev.adults > 1) {
          updated.adults -= 1;
        }
      }

      // Children
      if (type === "children") {
        if (action === "increment") {
          if (totalSelected < availableLimit && prev.children < maxChild) {
            updated.children += 1;
          }
        } else if (action === "decrement" && prev.children > 0) {
          updated.children -= 1;
        }
      }

      // Infants
      if (type === "infants") {
        if (action === "increment") {
          if (totalSelected < availableLimit && prev.infants < maxInfant) {
            updated.infants += 1;
          }
        } else if (action === "decrement" && prev.infants > 0) {
          updated.infants -= 1;
        }
      }

      return updated;
    });
  };

  const handleSaveGuests = () => {
    setGuests(participantCount);
    setShowGuestEditor(false);
  };

  const handleCancelGuests = () => {
    setTempGuests(guests); // revert changes
    setShowGuestEditor(false);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

   useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("confirm");
      setMeta(data);
    };

    loadMeta();
  }, []);

  const getCancellationDate = () => {
    const slot = currentSlot || slotDetails;
    if (!slot) return "";

    const duration = Number(experienceData?.data?.cancellation_duration || 0);

    // Extract parts safely
    const [year, month, day] = slotDate.split("-").map(Number);
    const [hour, minute, second] = slotDetails?.from_time
      .split(":")
      .map(Number);

    // Create date in LOCAL TIME (no timezone shift)
    const slotDateTime = new Date(year, month - 1, day, hour, minute, second);

    // Subtract cancellation days
    slotDateTime.setDate(slotDateTime.getDate() - duration);

    return slotDateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatTo12Hour = (timeStr) => {
    if (!timeStr) return "";
    const [hour, minute] = timeStr.split(":");
    const date = new Date();
    date.setHours(hour, minute);
    return date.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getExperienceUrl = (url_slug) => {
    return `/experience/${url_slug}`;
  };

  if (loading) {
    return (
      <div className="fullpage-loader">
        <div className="skeleton-box skeleton-title"></div>
        <div className="skeleton-box skeleton-subtitle"></div>
        <div className="skeleton-box skeleton-image"></div>
        <div className="skeleton-box skeleton-text"></div>
        <div className="skeleton-box skeleton-text"></div>
      </div>
    );
  }

  return (
    <>
      {/* <!-- Confirm and pay --> */}
      <section className="ser_v_araeea detailspgess checkout">
         <SetMetaTags
        title= {meta?.meta_title || "Confirm | Weyfarin"}
        description={meta?.meta_description || "Confirm | Weyfarin"}
      
      />
        <div className="container">
          <div className="top_bk_areaa">
            <Link className="ar_left" onClick={() => navigate(-1)}>
              <img src="/images/chevron-left.png" alt="Back" />
            </Link>{" "}
            Confirm and pay
          </div>
          <div className="row">
            <div className="col-lg-6 col-sm-6">
              <div className="conf_main_bx">
                <ul>
                  <li>
                    1. Log in or Sign up{" "}
                    <span className="ads_btnssrts">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setLoginOpen(true);
                        }}
                      >
                        Continue
                      </a>
                    </span>
                  </li>
                  <li>2. Add a payment method</li>
                  <li>3. Review your request</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6 col-sm-6">
              <div className="chek_bx_txt">
                <div className="meddils">
                  <div
                    className="mg_arease"
                    onClick={() =>
                      navigate(
                        getExperienceUrl(
                          experienceData?.data?.url_slug
                        ),
                      )
                    }
                  >
                    <img
                      src={
                        `${experienceData?.base_url}${experienceData?.data?.images?.[0]?.image}` ||
                        "/images/abt_tp_sm.png"
                      }
                      alt={experienceData?.data?.title || "Experience Image"}
                    />
                  </div>
                  <div className="dtls_rightss tetx_arease">
                    <h3
                      onClick={() =>
                        navigate(
                          getExperienceUrl(
                            experienceData?.data?.url_slug
                          ),
                        )
                      }
                    >
                      {experienceData?.data?.experience_title}
                    </h3>
                    <div className="us_listst">
                      <ul>
                        <li>
                          <i className="fa fa-star"></i>{" "}
                          {experienceData?.data?.rating} rating
                        </li>
                        <li
                          className={
                            experienceData?.data?.reviews_count > 0
                              ? ""
                              : "platforma_cursor"
                          }
                          onClick={() => {
                            if (experienceData?.data?.reviews_count > 0) {
                              navigate(
                                getExperienceUrl(
                                  experienceData?.data?.url_slug
                                ),
                              );
                            }
                          }}
                        >
                          {experienceData?.data?.reviews_count} reviews
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="ck_ckalsinss">
                    {experienceData?.data?.exp_cancel_status !== 2 && (
                      <div className="clk_liststs">
                        <h4>Free cancellation</h4>
                        <p>
                          Cancel before {getCancellationDate()} for a full
                          refund.
                        </p>
                      </div>
                    )}
                    <div className="clk_liststs">
                      <h4>Date & Time Slot</h4>

                      <p>
                        {slotDate
                          ? `${slotDate} | ${formatTo12Hour(slotDetails?.from_time)} - ${formatTo12Hour(slotDetails?.to_time)}`
                          : `${currentSlot?.slot_date} | ${formatTo12Hour(currentSlot?.from_time)} - ${formatTo12Hour(currentSlot?.to_time)}`}
                      </p>
                    </div>
                    <div className="clk_liststs">
                      <h4>Guests</h4>
                      {/* <p>
           
            {guests.adults} adult{guests.adults > 1 ? "s" : ""},{" "}
  {guests.children} child{guests.children !== 1 ? "ren" : ""},{" "}
  {guests.infants} infant{guests.infants !== 1 ? "s" : ""}

          </p> */}
                      <p>
                        {guests.adults > 0 && (
                          <>
                            {guests.adults} adult{guests.adults > 1 ? "s" : ""}
                            {guests.children > 0 || guests.infants > 0
                              ? ", "
                              : ""}
                          </>
                        )}
                        {guests.children > 0 && (
                          <>
                            {guests.children} child
                            {guests.children > 1 ? "ren" : ""}
                            {guests.infants > 0 ? ", " : ""}
                          </>
                        )}
                        {guests.infants > 0 && (
                          <>
                            {guests.infants} infant
                            {guests.infants > 1 ? "s" : ""}
                          </>
                        )}
                      </p>

                      <button
                        type="button"
                        className="ed_links"
                        onClick={() => {
                          setTempGuests(guests);
                          setShowGuestEditor(true);
                        }}
                      >
                        Edit
                      </button>

                      {/* Guest editor modal here (same as before) */}
                      {showGuestEditor && (
                        <div className="add_modalss all_modalss">
                          <div className="modal-container">
                            <h3>Edit Guests</h3>
                            <button
                              className="btn btn-secondary"
                              onClick={handleCancelGuests}
                            >
                              <img src="/images/cancel_c.png" alt="" />
                            </button>
                            <div className="main_area_sect">
                              <div className="us_cntens">
                                <p>Adults</p>
                                <span>Age 13+</span>
                              </div>
                              <div className="biths_adses">
                                <span
                                  className="addsss"
                                  onClick={() =>
                                    handleCountChange("adults", "decrement")
                                  }
                                >
                                  -
                                </span>
                                <input
                                  type="text"
                                  value={participantCount.adults}
                                  readOnly
                                  className="form-control"
                                />
                                <span
                                  className="addsss"
                                  onClick={() =>
                                    handleCountChange("adults", "increment")
                                  }
                                >
                                  +
                                </span>
                              </div>
                            </div>

                            <div className="main_area_sect">
                              <div className="us_cntens">
                                <p>Children</p>
                                <span>Age 4–12</span>
                              </div>
                              <div className="biths_adses">
                                <span
                                  className="addsss"
                                  onClick={() =>
                                    handleCountChange("children", "decrement")
                                  }
                                >
                                  -
                                </span>
                                <input
                                  type="text"
                                  value={participantCount.children}
                                  readOnly
                                  className="form-control"
                                />
                                <span
                                  className="addsss"
                                  onClick={() =>
                                    handleCountChange("children", "increment")
                                  }
                                >
                                  +
                                </span>
                              </div>
                            </div>

                            <div className="main_area_sect">
                              <div className="us_cntens">
                                <p>Infants</p>
                                <span>Under 2</span>
                              </div>
                              <div className="biths_adses">
                                <span
                                  className="addsss"
                                  onClick={() =>
                                    handleCountChange("infants", "decrement")
                                  }
                                >
                                  -
                                </span>
                                <input
                                  type="text"
                                  value={participantCount.infants}
                                  readOnly
                                  className="form-control"
                                />
                                <span
                                  className="addsss"
                                  onClick={() =>
                                    handleCountChange("infants", "increment")
                                  }
                                >
                                  +
                                </span>
                              </div>
                            </div>

                            <div className="modal-actions">
                              <button
                                className="btn btn-primary full_wdth"
                                onClick={handleSaveGuests}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="clk_liststs">
                      <h4>Price details</h4>
                      {/* <p>
    {currencysymbol}
    {Number(experienceData?.data?.price).toFixed(2)} ×{" "}
    {guests.adults || 0} adult
    <br />
    {currencysymbol}
    {Number(experienceData?.data?.child_price).toFixed(2)} ×{" "}
    {guests.children || 0} child
    <br />
    {currencysymbol}
    {Number(experienceData?.data?.infant_price).toFixed(2)} ×{" "}
    {guests.infants || 0} infant
    <span className="lst">
      {currencysymbol}
      {(
        (guests.adults || 0) * Number(experienceData?.data?.price) +
        (guests.children || 0) * Number(experienceData?.data?.child_price) +
        (guests.infants || 0) * Number(experienceData?.data?.infant_price)
      ).toFixed(2)}{" "}
      {currency || "AUD"}
    </span>
  </p> */}

                      <p>
                        {/* Adults */}
                        {guests.adults > 0 && (
                          <>
                            {currencysymbol}
                            {Number(experienceData?.data?.price || 0).toFixed(
                              2,
                            )}{" "}
                            × {guests.adults} adult
                            <br />
                          </>
                        )}

                        {/* Children */}
                        {guests.children > 0 && (
                          <>
                            {currencysymbol}
                            {Number(
                              experienceData?.data?.child_price || 0,
                            ).toFixed(2)}{" "}
                            × {guests.children} child
                            <br />
                          </>
                        )}

                        {/* Infants */}
                        {guests.infants > 0 && (
                          <>
                            {currencysymbol}
                            {Number(
                              experienceData?.data?.infant_price || 0,
                            ).toFixed(2)}{" "}
                            × {guests.infants} infant
                            <br />
                          </>
                        )}

                        {/* Total */}
                        <span className="lst">
                          {currencysymbol}
                          {(
                            (guests.adults || 0) *
                              Number(experienceData?.data?.price || 0) +
                            (guests.children || 0) *
                              Number(experienceData?.data?.child_price || 0) +
                            (guests.infants || 0) *
                              Number(experienceData?.data?.infant_price || 0)
                          ).toFixed(2)}{" "}
                          {currency || "AUD"}
                        </span>
                      </p>
                    </div>

                    <div className="clk_liststs">
                      <h4>
                        Total{" "}
                        <span className="lst">
                          {currencysymbol}
                          {(
                            (guests.adults || 0) *
                              Number(experienceData?.data?.price) +
                            (guests.children || 0) *
                              Number(experienceData?.data?.child_price) +
                            (guests.infants || 0) *
                              Number(experienceData?.data?.infant_price)
                          ).toFixed(2)}{" "}
                          {currency || "AUD"}
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ✅ Login Modal */}
      <LoginModal
        isOpen={loginOpen}
        onClose={() => setLoginOpen(false)}
        userType="1"
      />
    </>
  );
}

export default Confirm;
